import { Routes } from '@angular/router';

/**
 * Project routes
 */
export const ROUTES: Routes = [
  {
    path: '',
    // pathMatch: 'full',
    loadChildren: () => import('./_modules/landing-tc/landing-tc.module').then((m) => m.LandingTCModule)
  }
];
